const LIST_BOX_APPERANCES = ['boxed', 'flat'];
const LIST_BOX_HIGHLIGHT_OPTIONS = ['both', 'title', 'subtitle', 'none'];

export { LIST_BOX_APPERANCES, LIST_BOX_HIGHLIGHT_OPTIONS };
